module.exports = __webpack_public_path__ + "static/media/hexagonStylingRight.a44ab9d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Projects/Assets/hexagonStylingRight.svg
// module id = 512
// module chunks = 1